<template>
  <div>
    <v-alert v-if="loadError" type="error" text>{{ loadError }}</v-alert>
    <v-tabs v-if="datas.initfile" v-model="tab">
      <v-tab>SCAN</v-tab><v-tab>Fichier</v-tab>
    </v-tabs>
    <Scanner v-if="datas.success" v-show="tab === 0" :key="scannerKey"
      :config="datas" :idmodule="idmodule" :params="params" :querys="querys"
      :page="page" :modal-key="modalKey" :visible="tab === 0" />
    <div v-if="datas.initfile" v-show="tab === 1">
      <v-alert border="top" color="orange lighten-2" dark>{{ datas.mentionforfile }}</v-alert>
      <v-file-input v-model="chosenFile" label="Importer un fichier" required accept=".csv,.xlsx" outlined filled clearable class="ma-0 pa-0" />
      <v-btn @click="uploadFile" small class="text-center">Envoyer le fichier CSV</v-btn>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';
import { client } from '../mixins';
import Scanner from './Scanner.vue';
export default {
  mixins: [client],
  name: 'codeBarreC',
  components: { Scanner },
  data: () => ({ datas: {}, params: {}, querys: {}, tab: 0, chosenFile: null, loadError: '' }),
  computed: { scannerKey() { return this.datas.storage_scope || String(this.idmodule); } },
  methods: {
    uploadFile() {
      if (!this.chosenFile) {
        this.$toast.warning('Veuillez sélectionner un fichier avant d\'importer');
        return false;
      }

      this.$store.dispatch('textOverlay', 'Importation en cours');
      this.$store.dispatch('getoverlay', true);
      const formData = new FormData();
      formData.append('importFile', this.chosenFile);
      formData.append('id', this.idmodule);

      return this.API({
        type: 'post',
        url: 'displaymodule',
        params: formData,
        apidefault: { headers: { 'Content-Type': 'multipart/form-data' } },
      }).then((resp) => {
        this.$store.dispatch('getoverlay', false);
        if (!resp.data.success) {
          this.$toast.warning(resp.data.message);
          return false;
        }

        if (resp.data.waituser && confirm(resp.data.waituser)) {
          this.$store.dispatch('getoverlay', true);
          formData.append('allowInsertion', 1);
          return this.API({
            type: 'post',
            url: 'displaymodule',
            params: formData,
            apidefault: { headers: { 'Content-Type': 'multipart/form-data' } },
          }).then((resp2) => {
            this.chosenFile = null;
            this.$store.dispatch('getoverlay', false);
            if (!resp2.data.success) {
              this.$toast.warning(resp2.data.message);
              return false;
            }
            this.$toast.success(resp2.data.message);
            return true;
          });
        }

        return true;
      });
    },

  },
  async mounted() {
    const context = this.$store.getters.specificPage(this.modalKey) || {};
    this.params = this.customparams || context.params || {};
    this.querys = this.customquerys || context.querys || {};
    try {
      const response = await api.post('displaymodule', { id: this.idmodule, params: this.params, querys: this.querys }, { timeout: 30000 });
      if (!response.data.success) throw new Error(response.data.message || 'Module indisponible.');
      this.datas = response.data;
    } catch (e) { this.loadError = e.message || 'Impossible de charger le module.'; }
  },
};
</script>
